import { ESdChangeReason, LeftPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import KuikaTooltip from "../../ui-kit/kuika-tooltip/kuika-tooltip";
import { isLeftPanelButtonActive } from "./left-panel-rail";

export interface IRepotsButtonState {}

export interface IReportsButtonProps {
  onMenuItemClick?: (panelType: LeftPanelType) => void;
}

class ReportsButton extends PureSdComponent<IReportsButtonProps & IWithSDProps, IRepotsButtonState> {
  constructor(props: IReportsButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    if (this.props.onMenuItemClick) {
      this.props.onMenuItemClick(LeftPanelType.Reports);
    } else {
      this.props.sd.setActiveLeftPanelByClick(LeftPanelType.Reports);
    }
  };

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.ReportsButton) === Visibility.Visible && (
          <KuikaTooltip position="right" content="Reports">
            <KuikaButton
              data-testid="leftMenuReportsTabButton"
              type="tertiary"
              size="md"
              isIcon
              color="neutral"
              active={isLeftPanelButtonActive(this.props.sd, LeftPanelType.Reports)}
              onClick={this.handleClick}
            >
              <KuikaSvg type="sidebar-icons" name="file" width={18} height={18} pointer />
            </KuikaButton>
          </KuikaTooltip>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const reportsButton = withSD<IReportsButtonProps>(ReportsButton);
export { reportsButton as ReportsButton };
